<template>
  <div class="app-container">
    <div class="index-tree-box">
      <type-tree ref="type_tree" @on-select="onSelect" @title-click="titleClick" />
      <div class="right-box">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()" >
         <el-button type="success" plain @click="onImprot">导入</el-button>
         <el-button type="success" plain @click="onExport" >导出</el-button>
        <el-button type="primary" :disabled="!select.Id"  @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button v-if="$permission.canWrite()" type="text" @click="onEdit(row)">编辑</el-button>
            <el-button v-if="$permission.canWrite()" type="text" @click="oncCopy(row)">复制</el-button>
          </template>
        </el-table-column>
      </template>
    </list></div>
</div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />

  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/basedata/inventory/archives/list";
import editDialog from "@/components/basedata/inventory/archives/editDialog";
import importDialog from "@/components/basedata/inventory/archives/importDialog";

import typeTree from "@/components/basedata/inventory/archives/type/tree";

export default {
  name: "rank",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    typeTree,
  },
  data() {
    return {
      api: require("@/api/ba/product").default,
      select: {
        Id: null,
        Name: "",
      },
    };
  },
  mounted() {
    this.$refs.type_tree.getData();
  },
  methods: {
    onEdit(row) {
      row.isCopy = false;
      this.$refs.editDialog.openEdit(row);
    },
    oncCopy(row) {
      row.isCopy = true;
      this.$refs.editDialog.openEdit(row);
    }, 
    onImprot(){
       this.$refs.importDialog.open();
    },
    onExport() {
			this.$confirm("是否导出数据？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$refs.list.onExport();
				})
				.catch(() => { });
		},
    onSelect(data) {
      console.log(data,"data");
      this.select.Id = data.ClassId;
      this.select.Name = data.ClassName;
      this.$refs.list.queryParamsAppend.IdChain=data.IdChain;
      this.$refs.list.getData({ IdChain: data.IdChain, });
      // this.reload();
    },  
    titleClick() {
      this.select.Id = null;
      this.select.Name = "";
      this.$refs.list.queryParamsAppend.IdChain=null;
      this.$refs.list.getData({ IdChain: null });
    },
    create() {
      console.log('select',this.select.Id);
      this.$refs.editDialog.openCreate({
        ClassId: this.select.Id,
        ClassName: this.select.Name,
      });
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      let list = rows.filter(item => {
        return item.IsExistProductStock === true;
      })
      if(list.length !== 0){
        this.$message.warning("删除的数据不能包含已被引用的存货");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.ProductId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>